export default __webpack_public_path__ + "static/media/ISL_LOGO.a5cd906b.png";